module.exports = __webpack_public_path__ + "images/icons_v2/info-outlined-1fc4e428.svg";